import { X } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { availableTools } from '@/lib/tools';

interface SelectedToolsProps {
  selectedTools: string[];
  toggleTool: (toolId: string) => void;
}

const SelectedTools = ({ selectedTools, toggleTool }: SelectedToolsProps) => {
  if (selectedTools.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2 mt-2">
      {selectedTools.map(toolId => {
        const tool = availableTools.find(t => t.id === toolId);
        if (!tool) return null;
        
        return (
          <Badge 
            key={toolId} 
            variant="secondary"
            className="flex items-center gap-1.5 py-1 px-2.5 cursor-pointer bg-vibebops-highlight/80 hover:bg-vibebops-highlight"
            onClick={() => toggleTool(toolId)}
          >
            <div className="flex items-center justify-center">
              <tool.icon className="h-3.5 w-3.5" />
            </div>
            <span className="font-medium">{tool.name}</span>
            <X className="h-3 w-3 ml-0.5" />
          </Badge>
        );
      })}
    </div>
  );
};

export default SelectedTools; 